import React, { useEffect, useState, useRef } from 'react';
import { Button } from '@mui/material';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import { useHistory } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import { portalConfigurationTypes } from 'pages/Prequal/constants';
import { TabsOption } from 'global';
import { InventoryPageTabs } from 'modules/inventory/types';
import { TabsContainer } from 'components/shared/TabsContainer/TabsContainer';
import { CardBackground } from 'components/CardBackground/CardBackground';
import { PageContainer } from '../../components/shared/Page/PageContainer';
import { CardContainer } from '../../components/shared/CardContainer/CardContainer';
import { InventoryTable } from './InventoryTable';

interface Props {
  account: any;
  userProfile: any;
  portalConfiguration: any;
}

const ListInventory = ({ userProfile, account, portalConfiguration }: Props) => {
  const history = useHistory();
  const [initialTab, setInitialTab] = useState<InventoryPageTabs>(InventoryPageTabs.AllEquipment);

  const handleChangeTab = (newValue: InventoryPageTabs) => {
    history.push(
      `/inventory${
        newValue === InventoryPageTabs.AllEquipment
          ? ''
          : `/${newValue === InventoryPageTabs.AllEquipment ? 'menu' : 'dashboard'}`
      }`
    );
  };

  const [canWrite, setCanWrite] = useState(
    _.get(
      portalConfiguration,
      `${portalConfigurationTypes.inventory}.jsonDefinition.config.rolesSettings.assignedOnly`,
      []
    ).includes(userProfile.vendorContactRole)
  );
  const [canRead, setCanRead] = useState(
    _.get(
      portalConfiguration,
      `${portalConfigurationTypes.inventory}.jsonDefinition.config.rolesSettings.readOnly`,
      []
    ).includes(userProfile.vendorContactRole)
  );

  useEffect(() => {
    if (portalConfiguration && userProfile) {
      setCanWrite(
        _.get(
          portalConfiguration,
          `${portalConfigurationTypes.aftermarket}.jsonDefinition.config.rolesSettings.assignedOnly`,
          []
        ).includes(userProfile.vendorContactRole)
      );

      setCanRead(
        _.get(
          portalConfiguration,
          `${portalConfigurationTypes.aftermarket}.jsonDefinition.config.rolesSettings.readOnly`,
          []
        ).includes(userProfile.vendorContactRole)
      );
    }
  }, [portalConfiguration, userProfile]);

  const tabs: TabsOption<InventoryPageTabs>[] = [
    {
      label: InventoryPageTabs.AllEquipment,
      value: InventoryPageTabs.AllEquipment,
      isVisible: true,
      component: (
        <CardContainer
          title="List"
          sx={{ marginTop: '0.5rem' }}
          actionBtn={
            <Button
              variant="contained"
              color="primary"
              onClick={() => history.push('/equipment/new')}
              startIcon={<AddCircleOutlineIcon />}
            >
              Add Equipment
            </Button>
          }
        >
          {/* searchText={searchText} */}
          <InventoryTable accountId={account.id} />
        </CardContainer>
      ),
    },
  ];

  return (
    <PageContainer>
      <TabsContainer<InventoryPageTabs>
        tabs={tabs}
        initialTab={initialTab}
        onTabChange={handleChangeTab}
        TabsLabelWrapper={CardBackground}
      />
    </PageContainer>
  );
};

const mapStateToProps = (state: Props) => ({
  account: state.account,
  userProfile: state.userProfile,
  portalConfiguration: state.portalConfiguration,
});

export default connect(mapStateToProps, null)(ListInventory);
